// TODO(sergio): remove rule disabling
/* eslint-disable complexity */

import { Pipe, PipeTransform } from '@angular/core';
import {
  DomSanitizer,
  SafeHtml,
  SafeResourceUrl,
  SafeScript,
  SafeStyle,
  SafeUrl
} from '@angular/platform-browser';
import { TrustType } from '../../types/common.types';

/**
 * trust-content pipe bypass angular default security checks and blindly trust the content.
 * it allows binding dynamic html with inline styles and scripts.
 * useful when binding html via 'InnerHtml' attribute.
 * this pipe should never use over untrusted content such as user Input, which can include harmful content.
 * @see https://angular.io/api/platform-browser/DomSanitizer
 */

@Pipe({
  name: 'trustContent'
})
export class TrustContentPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(
    content: string,
    type: TrustType
  ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl | string {
    const svgURL = decodeURI(content);
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(content);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(content);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(content);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(content);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(content);
      case 'svg':
        return this.sanitizer.bypassSecurityTrustHtml(svgURL);
      default:
        return '';
    }
  }
}
